import partner from './partner.vue'

export default partner
